const zoneAlerts = [
  {
    id: "ALL NOTIFICATIONS",
    message: "ALL NOTIFICATIONS",
    name: "ALL",
    column: "enabled_all_notifications",
    disable_select: true,
  },
  {
    id: "CAMERA WEAPON",
    message: "CAMERA DETECTED WEAPON",
    name: "WEAPON DETECTED",
    column: "enabled_camera_weapon_detected_notifications",
    disable_select: true,
  },
  {
    id: "CAMERA FIRE",
    message: "CAMERA DETECTED FIRE OR SMOKE",
    name: "FIRE OR SMOKE DETECTED",
    column: "enabled_camera_fire_detected_notifications",
    disable_select: true,
  },
  {
    id: "CAMERA FIGHT",
    message: "CAMERA DETECTED FIGHT",
    name: "FIGHT DETECTED",
    column: "enabled_camera_fight_detected_notifications",
    disable_select: true,
  },
  {
    id: "CAMERA UNAUTHORIZED ENTRY",
    message: "CAMERA DETECTED UNAUTHORIZED ENTRY",
    name: "UNAUTHORIZED ENTRY",
    column: "enabled_camera_face_detected_notifications",
    disable_select: true,
  },
  {
    id: "CAMERA CROWD",
    message: "CAMERA DETECTED CROWD",
    name: "CROWD DETECTED",
    column: "enabled_camera_crowd_detected_notifications",
    disable_select: true,
  },
  {
    id: "CAMERA EVENT",
    message: "CAMERA EVENT",
    name: "CAMERA TRIGGERED",
    column: "enabled_camera_blanket_notifications",
    disable_select: true,
  },
  {
    id: "*** THIS IS ONLY A TEST ***",
    message: "*** THIS IS ONLY A TEST ***",
    name: "Test / Drill",
    column: "enabled_testdrill_notifications",
    rapidResponse: {
      TYPE: "PNB",
      EVENTCODE: "!E610",
      SIGNALSTATUS: "A",
    },
  },
  {
    id: "EMERGENCY ALERT REPORTED",
    message: "EMERGENCY ALERT REPORTED",
    name: "Emergency Alert",
    column: "enabled_emergency_notifications",
    rapidResponse: {
      TYPE: "PNB",
      EVENTCODE: "!QA",
      SIGNALSTATUS: "A",
    },
  },
  {
    id: "ACTIVE THREAT ALERT REPORTED",
    message: "ACTIVE THREAT ALERT REPORTED",
    name: "POLICE",
    column: "enabled_tas_notifications",
    rapidResponse: {
      TYPE: "POL",
      EVENTCODE: "ASA",
      SIGNALSTATUS: "A",
    },
  },
  {
    id: "MEDICAL EMERGENCY REPORTED",
    message: "MEDICAL EMERGENCY REPORTED",
    name: "Medical",
    column: "enabled_medical_notifications",
    rapidResponse: {
      TYPE: "MDB",
      EVENTCODE: "!MED",
      SIGNALSTATUS: "A",
    },
  },
  {
    id: "BUILDING LOCKDOWN ISSUED",
    message: "BUILDING LOCKDOWN ISSUED",
    name: "LOCKDOWN",
    column: "enabled_lockdown_notifications",
    rapidResponse: {
      TYPE: "PNB",
      EVENTCODE: "!QA",
      SIGNALSTATUS: "A",
    },
  },
  {
    id: "TORNADO WARNING REPORTED",
    message: "TORNADO WARNING REPORTED",
    name: "TORNADO WARNING",
    column: "enabled_tornado_notifications",
    rapidResponse: {
      TYPE: "ENV",
      EVENTCODE: "!ENV",
      SIGNALSTATUS: "A",
    },
  },
  {
    id: "SEVERE WEATHER REPORTED",
    message: "SEVERE WEATHER REPORTED",
    name: "SEVERE WEATHER",
    column: "enabled_weather_notifications",
    rapidResponse: {
      TYPE: "ENV",
      EVENTCODE: "!ENV",
      SIGNALSTATUS: "A",
    },
  },
  {
    id: "*** FALSE ALARM *** REPORTED",
    message: "*** FALSE ALARM *** REPORTED",
    name: "FALSE ALARM",
    column: "enabled_falsealert_notifications",
    rapidResponse: {
      TYPE: "CAN",
      EVENTCODE: "Cancel",
      SIGNALSTATUS: "X",
    },
  },
  {
    id: "SECURITY ALERT",
    message: "SECURITY ALERT",
    name: "SECURITY",
    column: "enabled_security_notifications",
    rapidResponse: {
      TYPE: "PNB",
      EVENTCODE: "!PA",
      SIGNALSTATUS: "A",
    },
  },
  {
    id: "DEVICE TAMPER ALERT - CHECK SECURITY SEAL",
    message: "DEVICE TAMPER ALERT - CHECK SECURITY SEAL",
    name: "TAMPER",
    column: "enabled_tamper_notifications",
    rapidResponse: {
      TYPE: "TAM",
      EVENTCODE: "!TAMP",
      SIGNALSTATUS: "TA",
    },
  },
];

export const filteredAlerts = () => {
  return zoneAlerts.filter((zone) => {
    if (zone.column === "enabled_all_notifications") return false;
    if (zone.disable_select) return false;
    return true;
  });
};
export default zoneAlerts;
